function extractAdditionalParams() {
  const url = (new URL(document.location.href));
  if (url.search.indexOf('?wl=1') > -1 || url.search.indexOf('&wl=1') > -1) {
    return 'wl=1';
  }
  return '';
}

/**
 * @param {boolean} isAvailable
 * @param {string} offerId
 *
 * @return {string}
 */
function buttonUrl(isAvailable, isBindingRequest, offerId) {
  if (offerId === undefined) {
    return '';
  }

  let url = `/ibe/request/${offerId}/`;
  if (isAvailable) {
    url = `/ibe/booking/${offerId}/`;
  } else if(isBindingRequest) {
    url = `/ibe/binding-request/${offerId}/`;
  }

  const additionalParams = extractAdditionalParams();
  if (additionalParams) {
    url = url + (url.indexOf('?') === -1 ? '?' : '&') + additionalParams;
  }

  return url;
}

export function button(state = { button: { text: '', url: '', additionalRequestUrl: '' } }, action) {
  if (state.labels && state.labels.Button && state.rate) {
    let text = null;
    if (state.wizardIsFetchingRate && typeof state.labels.Button.Check === 'string') {
      text = state.labels.Button.Check;
    } else if (state.rate.IsAvailable && typeof state.labels.Button.Book === 'string') {
      text = state.labels.Button.Book;
    } else if (state.rate.BindingRequest && typeof state.labels.Button.BindingRequest === 'string') {
      text = state.labels.Button.BindingRequest;
    } else if (typeof state.labels.Button.Request === 'string') {
      text = state.labels.Button.Request;
    }
    if (text) {
      state = {
        ...state,
        button: {
          ...state.button,
          text,
        },
      };
    }
  }

  if (state.rate && state.rate.OfferId && state.rate.IsAvailable !== undefined) {
    state = {
      ...state,
      button: {
        ...state.button,
        url: buttonUrl(state.rate.IsAvailable, state.rate.BindingRequest, state.rate.OfferId),
        additionalRequestUrl: buttonUrl(false, false, state.rate.OfferId),
      },
    };
  }

  return state;
}
